import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import CommonModal from './CommonModal.vue';
import { useCartStore } from '../../store/cart_store';
import CommonButton from '../CommonButton.vue';
import CartProductCard from '../CartProductCard.vue';
import { FormatUtils } from '@/infra/utils/format.utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'CartModal',
  setup(__props, { expose: __expose }) {

const cartModal = ref<InstanceType<typeof CommonModal>>();

__expose({
  open: (params?: {
    zIndex?: number;
  }) => {
    cartModal.value?.open({ zIndex: params?.zIndex ?? 3 });
  },
  close: () => {
    cartModal.value?.close();
  },
});

const cartStore = useCartStore();


const __returned__ = { cartModal, cartStore, CommonModal, CommonButton, CartProductCard, get FormatUtils() { return FormatUtils } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})